import React from 'react'
import { useQuery } from 'react-apollo'
import { sort } from 'ramda'
import Section from '../../shared/settings/section'
import MySavedDevicesCard from './devices/my-saved-devices-card'

import DEVICES_QUERY from '../../../../graphql/queries/devices.gql'
import { TESTERS } from '../../../lib/tester-classnames'

// Show only the five most recently active devices.
const getDevices = (deviceData) => {
  const devices = deviceData?.devices || []

  return sort((a, b) => {
    return new Date(b.lastSeen).getTime() - new Date(a.lastSeen).getTime()
  }, devices).slice(0, 5)
}

function DevicesAndDownloads() {
  const {
    data: deviceData,
    loading: deviceLoading,
    error: deviceError
  } = useQuery(DEVICES_QUERY, {
    fetchPolicy: 'network-only'
  })

  if (deviceLoading || deviceError) {
    return null
  }

  const devices = getDevices(deviceData)

  return (
    <Section title="Devices and Downloads" testerClassName={TESTERS.ACCOUNT.DEVICES_DOWNLOADS}>
      <MySavedDevicesCard
        devices={devices}
      />
    </Section>
  )
}

export default DevicesAndDownloads
